// angular
import {Injectable, inject} from "@angular/core";
import {Observable, fromEvent} from "rxjs";
import {io, Socket as IoSocket} from "socket.io-client";
// services
import {StorageService} from "./storage.service";
// env
import {environment} from "@environments/environment";

/** Socket wrapper matching the subset of ngx-socket-io used by messaging and emergency flows. */
export class AppSocket {
  readonly ioSocket: IoSocket;

  constructor(private readonly _socket: IoSocket) {
    this.ioSocket = _socket;
  }

  fromEvent<T>(eventName: string): Observable<T> {
    return fromEvent<T>(this._socket, eventName);
  }

  disconnect(): void {
    this._socket.disconnect();
  }
}

@Injectable()
export class SocketFactory {
  private sockets: Map<string, AppSocket> = new Map();

  private readonly _storageService = inject(StorageService);
  constructor() {}

  getSocket(namespace: string): AppSocket {
    const token = this._storageService.getToken();

    if (this.sockets.has(namespace)) {
      return this.sockets.get(namespace)!;
    }

    const url = `${environment.baseUrl}${namespace}`;
    const raw = io(url, {
      transports: ["websocket"],
      autoConnect: true,
      auth: {
        token,
      },
      query: {
        lang: "fa",
      },
    });

    const socket = new AppSocket(raw);
    this.sockets.set(namespace, socket);
    return socket;
  }

  disconnectAll() {
    this.sockets.forEach((socket) => {
      socket.disconnect();
    });
    this.sockets.clear();
  }
}
